/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Recorder_Increase_Font_Size_LabelInputs */

const en_audio_recorder_increase_font_size_label = /** @type {(inputs: Audio_Recorder_Increase_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase font size`)
};

const fr_audio_recorder_increase_font_size_label = /** @type {(inputs: Audio_Recorder_Increase_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Augmenter la taille de la police`)
};

const de_audio_recorder_increase_font_size_label = /** @type {(inputs: Audio_Recorder_Increase_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schriftgröße vergrößern`)
};

const it_audio_recorder_increase_font_size_label = /** @type {(inputs: Audio_Recorder_Increase_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumenta la dimensione del carattere`)
};

const ru_audio_recorder_increase_font_size_label = /** @type {(inputs: Audio_Recorder_Increase_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Увеличьте размер шрифта`)
};

const es_audio_recorder_increase_font_size_label = /** @type {(inputs: Audio_Recorder_Increase_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar el tamaño de la fuente`)
};

const zh_cn2_audio_recorder_increase_font_size_label = /** @type {(inputs: Audio_Recorder_Increase_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`增大字体大小`)
};

const ja_audio_recorder_increase_font_size_label = /** @type {(inputs: Audio_Recorder_Increase_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フォントサイズを大きくする`)
};

const hi_audio_recorder_increase_font_size_label = /** @type {(inputs: Audio_Recorder_Increase_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ॉन्ट का आकार बढ़ाएँ`)
};

const pt_pt2_audio_recorder_increase_font_size_label = /** @type {(inputs: Audio_Recorder_Increase_Font_Size_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumentar o tamanho da fonte`)
};

/**
* | output |
* | --- |
* | "Increase font size" |
*
* @param {Audio_Recorder_Increase_Font_Size_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_recorder_increase_font_size_label = /** @type {((inputs?: Audio_Recorder_Increase_Font_Size_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Recorder_Increase_Font_Size_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_recorder_increase_font_size_label(inputs)
	if (locale === "de") return de_audio_recorder_increase_font_size_label(inputs)
	if (locale === "it") return it_audio_recorder_increase_font_size_label(inputs)
	if (locale === "ru") return ru_audio_recorder_increase_font_size_label(inputs)
	if (locale === "es") return es_audio_recorder_increase_font_size_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_recorder_increase_font_size_label(inputs)
	if (locale === "ja") return ja_audio_recorder_increase_font_size_label(inputs)
	if (locale === "hi") return hi_audio_recorder_increase_font_size_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_recorder_increase_font_size_label(inputs)
	return en_audio_recorder_increase_font_size_label(inputs)
});